export default __webpack_public_path__ + "static/media/grafema_ummi_12.ba5fa3ec.jpg";